import React, { FC } from 'react';
import { SVG } from "./SVG";

export const ArrowUp: FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <SVG version="1.1" width="18" height="18"
         xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18 18"
         xmlSpace="preserve" {...props} isIcon isThemed>
        <path d="M5.6687312,2.3071434c0-0.5624855,0.4559793-1.0184758,1.0184646-1.0184758h9.1662064
                        c0.5625296,0,1.0185099,0.4559903,1.0185099,1.0184758v9.1662855c0,0.562418-0.4559803,1.0183973-1.0185099,1.0183973
                        c-0.562418,0-1.0183973-0.4559793-1.0183973-1.0183973V4.7659545L3.610558,15.9903336
                        c-0.3977373,0.3977604-1.0425968,0.3977604-1.4403346,0c-0.3977485-0.3976469-0.3977485-1.0425072,0-1.4402666L13.3946257,3.3256087
                        H6.6871958C6.1247106,3.3256087,5.6687312,2.8696291,5.6687312,2.3071434z"/>
    </SVG>
);